<template>
  <div class="register login-code">
    <a href="/" class="logo">
      <img src="/media/login/logo.png" alt="logo" />
    </a>
    <h4 class="title">ورود با کد در کاربن</h4>
    <p class="sub-title">
      رمز یکبار مصرف به شماره <span>{{ phoneNumber }}</span> ارسال شد
    </p>
    <div class="alert alert-error" v-if="errors.length">
      <div class="alert-content">
        <div class="alert-body">
          <p v-for="(item, i) in errors" :key="i">{{ item }}</p>
        </div>
      </div>
    </div>

    <form @submit.stop.prevent="onSubmit">
      <div class="code-config">
        <div
          class="
            code-config-fields
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <v-otp-input
            ref="otpInput"
            input-classes="form-control"
            separator=" "
            :num-inputs="6"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-complete="handleOnComplete"
            @on-change="handleOnChange"
          />
        </div>
        <div
          class="
            code-config-time
            d-flex
            align-items-center
            justify-content-between
          "
        >
          <div class="timear">
            ارسال مجدد کد در
            <span>00:00</span>
            ثانیه
          </div>
          <div class="timear-reset">ارسال مجدد کد</div>
          <a href="./index.html" class="link-form">تغییر شماره</a>
        </div>
        <div class="code-config-progress">
          <span></span>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <a href="./login-2.html" class="link-form">ورود با رمز عبور</a>
        <a href="./forget-password.html" class="link-form"
          >رمزم را فراموش کردم</a
        >
      </div>
      <button type="submit" class="btn btn-primary" ref="login-button" disabled>
        <span class="loading-wrapper" ref="login-span">
          <span class="button__text">ورود</span>
        </span>
      </button>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Confirmation",
  components: {
    //   OtpInput
  },
  data() {
    return {
      code1: "",
      code2: "",
    };
  },
  methods: {
    handleOnChange(value) {
      if (value.length < 6) {
        const loginButton = this.$refs["login-button"];
        loginButton.setAttribute("disabled", "disabled");
      }
    },
    handleOnComplete(value) {
      if (value.length == 6) {
        const loginButton = this.$refs["login-button"];
        const loginSpan = this.$refs["login-span"];
        loginButton.removeAttribute("disabled");

        loginButton.classList.add("waiting");
        loginSpan.classList.add("button--loading");

        this.$store
          .dispatch("auth/login", {
            Username: this.phoneNumber,
            Password: "",
            Code: value,
            RememberMe: true,
            grant_type: "password",
          })
          // go to which page after successfully login
          .then(({ data }) => {
            console.log(data);
            this.$router.push({ name: "dashboard" });
          })
          .catch(function (error) {
            console.log("error is ", error);
          })
          .finally(() => {
            loginButton.classList.remove("waiting");
            loginSpan.classList.remove("button--loading");
          });
      }
    },
  },
  computed: {
    ...mapState({
        errors: (state) => state.auth.errors,
      phoneNumber: (state) => state.auth.phoneNumber,
    }),
  },
  mounted() {},
};
</script>
